import { FiClock } from "react-icons/fi";
import {
  RiUserSearchLine,
  RiAdminLine,
  RiHome3Line,
  RiUserLine,
} from "react-icons/ri";
import { BiChip, BiSearchAlt, BiImage } from "react-icons/bi";

// Шинэ админ (fe-adminviot-v3) руу шилжсэн цэсүүдийг хассан (2026-10): хэрэглэгчийн
// мэдэгдэл/төлбөр/гомдол/байршил, нэхэмжлэх, API service (шинэ админ → Тохиргоо →
// API service), систем. Хуудаснууд нь App.js-д хэвээр — шууд линкээр нээгдэнэ.
export const navData = [
  {
    title: "Хяналтын самбар",
    toLink: "/dashboard",
    icon: RiHome3Line,
  },
  {
    title: "Төхөөрөмж",
    toLink: "/device",
    icon: BiChip,
    subTitle: [
      {
        title: "Төхөөрөмж нэмэх",
        toLink: "/device/type",
        icon: BiChip,
      },
      {
        title: "Interval",
        toLink: "/device/interval",
        icon: FiClock,
      },
      {
        title: "Төхөөрөмж хайх",
        toLink: "/device/search",
        icon: BiSearchAlt,
      },
    ],
  },
  {
    title: "Хэрэглэгч",
    toLink: "/User",
    icon: RiUserLine,
    subTitle: [
      {
        title: "Хэрэглэгч хайх",
        toLink: "/User/find",
        icon: RiUserSearchLine,
      },
    ],
  },
  {
    title: "Профайл",
    toLink: "/profile",
    icon: RiUserLine,
  },
  {
    title: "Баннер",
    toLink: "/banner",
    icon: BiImage,
  },
  {
    title: "Админы жагсаалт",
    toLink: "/admin-list",
    icon: RiAdminLine,
  },
  // {
  //   title: "RC/DC мэдэгдэл",
  //   toLink: "/notification",
  //   icon: MdOutlineNotificationsNone,
  // },
  {
    title: "login",
    toLink: "/login",
    icon: RiHome3Line,
  },
];
